import { FC } from 'react';

import {
  createSelectionContext,
  SelectionContextState,
  useSelectionContext,
} from 'utils/contexts/selection';

import { CampaignId } from '../../domainTypes';
import { useCampaignQueryContext } from './CampaignQueryContext';

export type TemplateSelectionContext = SelectionContextState<CampaignId>;

const [TemplateSelectionContext, useTemplateSelectionContext] =
  createSelectionContext<CampaignId>();

export {
  TemplateSelectionContext as SelectionContext,
  useTemplateSelectionContext as useSelectionContext,
};

export const SelectionContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { folderId, folders, campaigns } = useCampaignQueryContext();
  const context = useSelectionContext<CampaignId>({
    folderId,
    folders,
    contentItems: campaigns,
  });

  return (
    <TemplateSelectionContext.Provider value={context}>
      {children}
    </TemplateSelectionContext.Provider>
  );
};
